import { createStore } from '@aibees/shared/store';
import { ProgressBarStoreData as StoreData } from './types';

const useProgressBarStore = createStore<StoreData>('progress-bar', (set) => ({
  enable: false,
  value: 0,
  setEnable: (enable: boolean) => set({ enable }),
  setValue: (value: number) => set({ value }),
}));

export default useProgressBarStore;
